// legacy/workaround: BE-generated auth links (activation, password reset,
// email-change confirmation) emit unencoded `+` chars in query params
// (e.g. `email=chris.miller+strata@spark.re`). URLSearchParams follows
// form-encoding rules and decodes `+` to a space, mangling plus-addressed
// emails. Re-encode literal `+` as `%2B` before parsing so the standard
// URLSearchParams API can be used safely. Remove once the BE encodes
// `+` as `%2B` at link-generation time.
export const parseSearchPreservingPlus = (search: string): URLSearchParams =>
  new URLSearchParams(search.replace(/\+/g, '%2B'));
